<template>
<div class="col-12 text-left">
    <h3 class="align-left">
        <small class="text-muted">Sample Journey</small>
    </h3>
    <div class="dropdown-divider"></div>
    <app-status-count></app-status-count>
    <app-modal :elements="modalElements" v-on:confirm="del"></app-modal>
    <app-data-search v-on:searching="search"></app-data-search>
    <!-- <button type="button" class="btn btn-outline-primary" @click="add">Add  <i class="far fa-file"></i></button> -->
    <button type="button" class="btn btn-outline-info" @click="edit">Edit <i class="far fa-edit"></i></button>
    <!-- <button type="button" class="btn btn-outline-danger" data-toggle="modal" :data-target="`#${modalElements.modalId}`">Delete <i class="far fa-trash-alt"></i></button> -->
    <!-- <button type="button" class="btn btn-outline-success" @click="preview">Preview <i class="fas fa-print"></i></button> -->
    <br /><br />
    <app-datatable :type="'view'" :elements="dtElements" :collections="sj" v-on:selectedRow="selectRow"></app-datatable>
    <app-data-pagination v-on:pageChanged="changePage"></app-data-pagination>
</div>
</template>

<script>
import api from '../../services/api'
import { sampleJourney } from '../../models/sampleJourney'
import AppDatatable from '../../components/AppDatatable.vue'
import AppModal from '../../components/AppModal.vue'
import AppDataPagination from '../../components/AppDataPagination.vue'
import AppDataSearch from '../../components/AppDataSearch.vue'
import AppStatusCount from '../../components/AppStatusCount.vue'

export default {
  components: {
    AppDatatable, AppModal, AppDataPagination, AppDataSearch, AppStatusCount
  },
  data() {
    return {
      sj: [sampleJourney],
      dtElements: [
        {
          title: 'SR Number',
          column: 'srNumber',
          type: 'text',
          width: 3
        },
        {
          title: 'Start Date',
          column: 'startDate',
          type: 'date'
        },
        {
          title: 'Due Date',
          column: 'dueDate',
          type: 'date'
        },
        {
          title: 'Product',
          column: 'product',
          type: 'text'
        },
        {
          title: 'Complete Date',
          column: 'completeDate',
          type: 'text'
        },
        {
          title: 'Remark Sample Journey',
          column: 'remarkSampleJourney',
          type: 'text'
        },
        {
          title: 'Customer',
          column: 'customer',
          type: 'text'
        },
        {
          title: 'Destination',
          column: 'destination',
          type: 'text'
        },
        {
          title: 'Transaction Status',
          column: 'transactionStatus',
          type: 'text'
        },
        {
          title: 'Gantt Status',
          column: 'ganttStatus',
          type: 'text'
        },
        {
          title: 'Address',
          column: 'address',
          type: 'text',
          width: 5
        },
        {
          title: 'Approved By',
          column: 'approvedByName',
          type: 'text'
        },
        {
          title: 'Remark',
          column: 'remark',
          type: 'text'
        },
        {
          title: 'Created At',
          column: 'createdAt',
          type: 'text'
        },
        {
          title: 'Created By',
          column: 'createdBy',
          type: 'text'
        },
        {
          title: 'Last Updated At',
          column: 'updatedAt',
          type: 'text'
        },
        {
          title: 'Updated By',
          column: 'updatedBy',
          type: 'text'
        }
      ],
      modalElements: {
          modalId: 'request-sample',
          title: 'Confirm',
          content: 'Are you sure to delete this data?',
          type: 'text-confirm'
      },
      selectedId: '',
      searchKey: '',
      pagination: {
          pageSize: 10,
          currentPage: 1
      },
    }
  },
  async created() {
    this.init()
  },
  methods: {
    async init() {
      const sjApi = api('sample-journey/partial')
      const query = {
        params: {
          searchKey: this.searchKey,
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize
        }
      }
      // this.rs = await rsApi.getWithQuery(query) 
      const sjResult = await sjApi.getWithQuery(query) 
      this.sj = sjResult
    },
    add() {
      this.$router.push({ name: 'sampleJourneyDetail' })
    },
    edit() {
      if(this.selectedId !== '') {
        this.$router.push({
          name: 'sampleJourneyDetail',
          query: {
            id: this.selectedId
          }
        })
      }
    },
    preview() {
      if(this.selectedId !== '') {
        this.$router.push({
          name: 'requestSamplePartial',
          query: {
            id: this.selectedId
          }
        })
      }
    },
    async del() {
      if(this.selectedId !== '') {
        const rsApi = api('request-sample')
        await rsApi.delete(this.selectedId)
        this.init()
      }
    },
    selectRow(id) {
      this.selectedId = id
    },
    changePage(payload) {
      this.pagination = payload
      this.init()
    },
    search(searchKey) {
      this.searchKey = searchKey
      this.init()
    }
  }
}
</script>